import lng from '@lightningjs/core';
import { Router } from '@lightningjs/sdk';

export default class PublicRoute extends lng.Component {
  static _template() {
    return {
      x: 0,
      y: 0,
      w: 1920,
      h: 1080,
      SectionsContainer: {},
    };
  }

  _getFocused() {
    return this._SectionsContainer;
  }

  _transitionSection(selected) {
    let transition = this._sectionTransitions[selected.ref] || {};
    this.patch(transition);
  }

  navigate(path) {
    Router.navigate(path);
  }

  reset() {
    this._SectionsContainer.selectedIndex = 0;
  }

  get _SectionsContainer() {
    return this.tag('SectionsContainer');
  }
}
